/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Status_DescriptionInputs */



/**
* | output |
* | --- |
* | "Stored encrypted. Used for all calls from members of this organization." |
*
* @param {Integrations_Credentials_Status_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_status_description = /** @type {((inputs?: Integrations_Credentials_Status_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Status_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschlüsselt gespeichert. Wird für alle Aufrufe der Mitglieder dieser Organisation verwendet.")
	return /** @type {LocalizedString} */ ("Stored encrypted. Used for all calls from members of this organization.")
});